import Axios from 'axios'
import { getCookie, setCookie } from './cookie'
import Api from './api.js'
import { setTimeout } from 'core-js';
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';
var errFlag = true;//解决循环弹出错误提示标识
var noUseFlag = true;//解决循环弹出"服务不可以，联系管理员"标识
import store from "../../src/store"

let pendingRequestArr = [];//保存pending状态的网络请求 
let isLoginType = false;
export function request(config) {
	// console.log(config,'www')
	if(config.data?.isLoginType){
		isLoginType = true
	}
	const router = useRouter();
	let cancelToken = Axios.CancelToken;
  	let authorization = ''
	// let authorization = 'bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJtYWlqaWEwMSIsInVzZXJfbmFtZSI6Im1haWppYTAxIiwib3BlbklkIjoiOTUzMzRkNTkxODk2NDYyMzhjMWVhMDkzMjFhN2NiYTMiLCJ1c2VySWQiOjUwNTgyMzI4OTQ3NDg1MTUyNCwiYXV0aG9yaXRpZXMiOlsiUk9MRV9hY2NvdW50IiwiUk9MRV91c2VyIl0sImV4cCI6MTcxNzQyMjE0OH0.GGlX1fieQafyb-BgsgQKhrWgCAobFzivQegFqn0xRoM7rCInI458i2nnevIbYCxlbvPObAz_uMrKk-NhPRJVnw_adFw5mxO_d2dB5DfkujQQGCQxTp1O7B_I_QQBO8AyEEl5GsA6QShRTn6ctMoKMoqtRzS_gH3bx2CUE-vGx5w1OnVWF60GwpYQ9q7oK0iaZW8cypprMHA4ZbXjn_9uPOA7cM2WfShNDXxPd1THFJ4TPiMoXnbL3ur6vD51o3PDPPiokIsEgh1MWNiJqBZkEZw03VDmCflpCiNJyC2I3iAsMXa1U-0J_mjPhEn1YWQ4hqBKD-K70fYrNByWFUuqIg'
	if (getCookie("userInfoB2B")) {
		if (JSON.parse(getCookie("userInfoB2B"))) {
			authorization = JSON.parse(getCookie("userInfoB2B")).tokenType + " " + JSON.parse(getCookie("userInfoB2B")).accessToken
		}
	}
	setCookie('authorizationB2B',authorization)
	// setCookie('authorizationB2B',authorization)
	//取消请求fn
	let cancelPendingFn = (res) => {
		console.log(res)
		// pendingRequestArr.forEach((item,index)=>{
		// 	if(item.url==res.url){
		// 		item.cancelFn();
		// 		pendingRequestArr.splice(index,1);//从数组移除当前请求记录
		// 	}
		// })
	}
  console.log(authorization)
	//创建Axios实例，添加通用配置
	const instance = Axios.create({
		method: config.method ? config.method : "post",
		timeout: 30000,
		headers: config.header ? config.header : {
			// 'content-type': 'application/json',
			'Authorization': authorization,
			'withCredentials': true
		},
	})


	//实例请求拦截器
	instance.interceptors.request.use((res) => {
		return new Promise(resolve=>{
			setTimeout(()=>{
				cancelPendingFn(res);
				if(!res.url){return}
				if(res.url && res.url.substr(0,4).toLowerCase() == "http" ){
					res.url;
				}else{
					res.url = process.env.VUE_APP_BASE_API+Api[res.url]
          console.log(res.url)
				}
				res.cancelToken = new cancelToken((cancelFn) => {
					pendingRequestArr.push({ "url": res.url, "cancelFn": cancelFn })
				})
				resolve(res)
			},300)
		})
	}, (err) => {
		return Promise.reject(err);
	})

	//实例响应拦截器
	instance.interceptors.response.use((res) => {
		console.log(res.data.code && res.data.code!='000')
		if(res.data.code && res.data.code!='000'){
			if (noUseFlag && !res.config.cancelMsg) {
				noUseFlag = false;
				ElMessage.error({
					message: res.data.msg,
					duration: '2500',
					onClose: function () {
						noUseFlag = true;
					}
				});
			}
		}
		cancelPendingFn(res.config);
		return res;
	}, (error) => {
		console.log(error);

		let err = error.response;
		if (errFlag) {
			if(err){
				if (err.status == "401") {
					setCookie('userInfoB2B', '');
					setCookie('loginName', '');
					store.commit('setUserInfoB2B', '');
					if(!isLoginType){
						router.push('/login')
					}
				} else if (err.status == "500") {
					// errFlag = false;
					ElMessage({
						message: err.data.msg,
						onClose: function () {
							errFlag = true;
						}
					});
				}
			}else{
				ElMessage({
					message: err.message,
					onClose: function () {
						errFlag = true;
					}
				});
			}
			
		}



		// var isErrInfo = err.response.data.error_description.indexOf('Access token expired');//权限是否过期
		//    var isErrInfo1 = err.response.data.error_description.indexOf('An Authentication object was not found in the SecurityContext');//没有token串
		//       if(errFlag) {
		//         if( isErrInfo>=0 ) {
		//           setCookie('userInfoB2B','');
		//           setCookie('loginName','');
		//           localStorage.setItem("menuBuyType","");
		//           errFlag = false;
		//           vm.$router.push('/'); 
		//         } else if( isErrInfo1>=0 ) {
		//           errFlag = false;
		//           vm.$router.push('/'); 
		//         } else {
		//           ElMessage('服务暂时不可用，请联系管理员');
		//         }
		//         return false;
		//       }
		//return Promise.reject(err);
		return Promise.reject(err).catch((error) => {
			if (error.data == "server exception: code = 404 msg = Not Found") {//说明没开通此服务
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: '服务暂时不可用，请联系管理员',
						duration: '4000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			if (error.status == '500') {
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: error.data.msg ? error.data.msg : '服务端异常',
						duration: '3000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			if (error.status == '403') {
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: error.data.msg ? error.data.msg : '服务端异常',
						duration: '3000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			return Promise.reject(err);//为了在具体页面请求中 catch中获取错误信息
		});
		
	})

	//返回axios的实例，也是一个promise
	return instance(config)
	
}

/*
具体页面中使用方式
request({
	url:"xxxx",
	method:"post",
	data:{},
}).then((res)=>{

}).catch((err)=>{

})

*/
